import EnercityAppButton from '@/page-templates/EnercityAppRedirectPage/EnercityAppButton';
import Image from 'next/image';
import EnercityAppIcon from '../EnercityAppIcon/EnercityAppIcon';
import styles from './BenefitsOverviewAppBanner.module.scss';
import Phone from './assets/phone.png';

const BenefitsOverviewAppBanner = () => {
  return (
    <div className={styles.base}>
      <div className={styles.iconWrapper}>
        <EnercityAppIcon />
      </div>

      <h2 className={styles.title}>
        Sichern Sie sich exklusive Vorteile in der enercity App
      </h2>

      <div className={styles.buttons}>
        <EnercityAppButton variant="ios" name="Apple App Store" />
        <EnercityAppButton variant="android" name="Google Play Store" />
      </div>

      <Image
        src={Phone.src}
        width={392}
        height={648}
        alt="Ein Smartphone, das die enercity App zeigt"
        unoptimized={true}
        className={styles.image}
      />
    </div>
  );
};

export default BenefitsOverviewAppBanner;
